import script from "./app_confirm_dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./app_confirm_dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__